var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',{attrs:{"small-chips":"","multiple":"","label":_vm.$t('Select_file')},on:{"change":function($event){return _vm.$emit('input', _vm.files)}},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})
}
var staticRenderFns = []

export { render, staticRenderFns }